// 絞り込み（品詞・モーラ数）と並び替え。
// 絞り込みは詳細設定パネルが開いていれば常に全項目を表示、並び替えは常時表示（結果ヘッダに常駐）。

import type { ResultFilter, SortOrder } from '../workers/searchClient'

const MORA_MAX_CHOICE = 12

const SORTS: Array<{ id: SortOrder; label: string }> = [
  { id: 'freq', label: 'よく使う順' },
  { id: 'mora', label: 'みじかい順' },
  { id: 'kana', label: 'あいうえお順' },
]

/** 並び替え。折りたたまず常時表示する（結果件数の隣に置く想定）。 */
export function SortSelect({
  sort,
  onSort,
}: {
  sort: SortOrder
  onSort: (s: SortOrder) => void
}) {
  return (
    <select
      value={sort}
      onChange={(e) => onSort(e.target.value as SortOrder)}
      aria-label="並び替え"
      className="shrink-0 rounded-lg border border-line bg-card px-2 py-1 text-xs text-ink"
    >
      {SORTS.map((s) => (
        <option key={s.id} value={s.id}>
          {s.label}
        </option>
      ))}
    </select>
  )
}

function MoraSelect({
  label,
  value,
  onChange,
}: {
  label: string
  value: number | undefined
  onChange: (v: number | undefined) => void
}) {
  return (
    <select
      value={value ?? 0}
      onChange={(e) => onChange(Number(e.target.value) || undefined)}
      aria-label={label}
      className="rounded-lg border border-line bg-card px-2 py-1.5 text-sm text-ink"
    >
      <option value={0}>指定なし</option>
      {Array.from({ length: MORA_MAX_CHOICE }, (_, i) => i + 1).map((n) => (
        <option key={n} value={n}>
          {n}
        </option>
      ))}
    </select>
  )
}

export function RefinePanel({
  posLegend,
  filter,
  onFilter,
}: {
  posLegend: string[]
  filter: ResultFilter
  onFilter: (f: ResultFilter) => void
}) {
  const togglePos = (i: number) => {
    const cur = filter.pos ?? []
    const next = cur.includes(i) ? cur.filter((v) => v !== i) : [...cur, i]
    onFilter({ ...filter, pos: next.length > 0 ? next : undefined })
  }

  return (
    <div className="space-y-2 rounded-lg bg-paper p-3">
      <div className="text-xs text-mut">絞り込み</div>
      <div className="flex flex-wrap gap-1.5">
        {posLegend.map((label, i) => {
          const on = filter.pos?.includes(i) ?? false
          return (
            <button
              key={i}
              type="button"
              onClick={() => togglePos(i)}
              aria-pressed={on}
              className={`rounded-lg border px-2 py-1 text-sm transition ${
                on
                  ? 'border-transparent bg-gradient-to-r from-accent-pink to-accent-vio text-white'
                  : 'border-line bg-card text-mut hover:border-mut/50'
              }`}
            >
              {label}
            </button>
          )
        })}
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm text-mut">
        <span>モーラ数</span>
        <MoraSelect
          label="モーラ数の下限"
          value={filter.moraMin}
          onChange={(v) => onFilter({ ...filter, moraMin: v })}
        />
        <span>〜</span>
        <MoraSelect
          label="モーラ数の上限"
          value={filter.moraMax}
          onChange={(v) => onFilter({ ...filter, moraMax: v })}
        />
      </div>
    </div>
  )
}
